<template>
  <nav aria-label="breadcrumb" role="navigation">
    <ol class="breadcrumb">
      <slot>

      </slot>
    </ol>
  </nav>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'breadcrumb',
});
</script>
<style>
</style>
